import Usage from "sections/subscription/usage";
import MobileHeader from "components/mobile-header";
import Overview from "sections/subscription/overview";
import DashboardHeader from "components/dashboard-header";
import PlanAndBilling from "sections/subscription/plan-and-billing";

const Subscription = () => {
  return (
    <div className="w-full px-4 md:px-6 lg:px-6">
      <MobileHeader />

      <div className="flex items-center justify-between border-b border-solid border-brand-header-border mb-4 mt-2 lg:mt-0 pb-4 lg:pb-2.5">
        <DashboardHeader label={"Subscription"} className={"xl:max-w-[850px] w-full mt-4 lg:w-full"} />
      </div>
      
      <Overview />

      <DashboardHeader label={"Usage"} className={"mb-11 xl:max-w-[850px]"} />

      <Usage />

      <DashboardHeader label={"Plan & Billing"} className={"mb-11 xl:max-w-[850px]"} />

      <PlanAndBilling />
    </div>
  );
};

export default Subscription;